import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {makeAction} from '../../redux/actions/makeAction';
import {PROFILE_FETCH, REQUEST_PROFILE_EDIT_CODE} from '../../redux/actions/actionTypes';
import {
  userEmailSelector,
  userUsernameSelector,
  walletSelector,
  dashboardTokenSelector,
  dateCreatedSelector,
  lastLoginSelector,
  lastIPAddressSelector,
} from '../../redux/selectors/user';
import {Button, Card, Col, Row} from 'antd';
import moment from 'moment';
import ProfileItem from './profile/ProfileItem';
import ChangeEmailModal from '../modals/profile/ChangeEmailModal';
import {
  PROFILE_EDIT_EMAIL_MODAL_ID,
  PROFILE_EDIT_PASSWORD_MODAL_ID,
  PROFILE_EDIT_WALLET_MODAL_ID,
} from '../../services/constants';
import ChangePasswordModal from '../modals/profile/ChangePasswordModal';
import ChangeWalletModal from '../modals/profile/ChangeWalletModal';
import TranslatedText from '../TranslatedText';
import {showConfirmation} from '../../services/notifications';
import {withTranslation} from 'react-i18next';

class ProfilePage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.sendCode = this.sendCode.bind(this);
    this.copyUrl = this.copyUrl.bind(this);
    this.getDashboardTokenUrl = this.getDashboardTokenUrl.bind(this);
  }

  componentDidMount() {
    this.props.fetchProfile();
  }

  sendCode() {
    this.props.requestProfileEditCode({
      email: this.props.email,
    });
  }

  getDashboardTokenUrl() {
    return `${window.location.origin}/dashboard?dashboardToken=${this.props.dashboardToken}`;
  }

  copyUrl() {
    if (this.props.dashboardToken) {
      const dummy = document.createElement('textarea');
      document.body.appendChild(dummy);
      dummy.value = this.getDashboardTokenUrl();
      dummy.select();
      document.execCommand('copy');
      document.body.removeChild(dummy);
      showConfirmation(
        <TranslatedText transKey="profile.url.copyNotificationTitle"/>,
        <TranslatedText transKey="profile.url.copyNotificationContent"/>
      );
    }
  }

  render() {
    return (
      <div className="container">
        <Row gutter={20}>
          <Col xs={24} xl={12} className="profile-card profile-account-card">
            <Card bordered={false}>
              <h2><TranslatedText transKey="profile.account.title"/></h2>
              <ProfileItem value={this.props.username} label={<TranslatedText transKey="profile.account.username"/>}/>
              <ProfileItem
                value={this.props.wallet || this.props.t('profile.account.wallet.empty')}
                editable
                modalId={PROFILE_EDIT_WALLET_MODAL_ID}
                onChange={this.sendCode}
                label={<TranslatedText transKey="profile.account.wallet"/>}
              />
              <ProfileItem value={moment(this.props.dateCreated).format('LLL')} label={<TranslatedText transKey="profile.account.registered"/>}/>
            </Card>
          </Col>
          <Col xs={24} xl={12} className="profile-card profile-security-card">
            <Card bordered={false}>
              <h2><TranslatedText transKey="profile.security.title"/></h2>
              <ProfileItem label={<TranslatedText transKey="profile.security.email"/>} value={this.props.email} editable
                           modalId={PROFILE_EDIT_EMAIL_MODAL_ID} onChange={this.sendCode}/>
              <ProfileItem label={<TranslatedText transKey="profile.security.password"/>} value="************" editable
                           modalId={PROFILE_EDIT_PASSWORD_MODAL_ID} onChange={this.sendCode}/>
              <ProfileItem value={moment(this.props.lastLogin).format('LLL') + ', ' + this.props.lastIPAddress} label={<TranslatedText transKey="profile.security.lastLogin"/>}/>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col span={24} className="profile-card profile-url-card">
            <Card bordered={false}>
              <h2><TranslatedText transKey="profile.url.title"/></h2>
              <ProfileItem large label={<TranslatedText transKey="profile.url.dashboardToken"/>}
                           value={this.getDashboardTokenUrl()} onChange={this.sendCode}>
                <Button type="primary" onClick={this.copyUrl}>
                  <TranslatedText transKey="profile.url.copyButton"/>
                </Button>
              </ProfileItem>
            </Card>
          </Col>
        </Row>
        <ChangeEmailModal/>
        <ChangePasswordModal/>
        <ChangeWalletModal/>
      </div>
    );
  }
}

ProfilePage.propTypes = {
  wallet: PropTypes.string,
  email: PropTypes.string,
  username: PropTypes.string,
  dashboardToken: PropTypes.string,
  dateCreated: PropTypes.string,
  lastLogin: PropTypes.string,
  lastIPAddress: PropTypes.string,
  fetchProfile: PropTypes.func.isRequired,
  requestProfileEditCode: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  wallet: walletSelector(state),
  email: userEmailSelector(state),
  username: userUsernameSelector(state),
  dashboardToken: dashboardTokenSelector(state),
  dateCreated: dateCreatedSelector(state),
  lastLogin: lastLoginSelector(state),
  lastIPAddress: lastIPAddressSelector(state),
});

const mapDispatchToProps = {
  fetchProfile: makeAction(PROFILE_FETCH),
  requestProfileEditCode: makeAction(REQUEST_PROFILE_EDIT_CODE),
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ProfilePage));



// WEBPACK FOOTER //
// /src/components/pages/ProfilePage.jsx